export default __webpack_public_path__ + "static/media/ArOverviewSearchBg.14bdb7b2.jpg";